import type { Theme } from '@mui/material/styles';
import { SubscriptionTier, tierLabel } from '@nexus/supabase';

// Theme palette entries used for logo-less workspace avatars.
const AVATAR_PALETTE = [
  ['primary', 'main'],
  ['primary', 'dark'],
  ['info', 'main'],
  ['info', 'dark'],
  ['warning', 'main'],
  ['warning', 'dark'],
  ['success', 'main'],
  ['error', 'light'],
] as const;

function hash(value: string): number {
  let result = 0;
  for (let i = 0; i < value.length; i += 1) {
    result = (result * 31 + value.charCodeAt(i)) % 2147483647;
  }
  return result;
}

export function workspaceAvatarColor(theme: Theme, name: string): string {
  const [color, shade] = AVATAR_PALETTE[hash(name) % AVATAR_PALETTE.length];
  return theme.palette[color][shade];
}

/** "Core plan" / "Ultra plan" — the workspace's subscription, in one line. */
export function workspacePlanLabel(tier: SubscriptionTier): string {
  return `${tierLabel(tier)} plan`;
}
